module.exports = __webpack_public_path__ + "static/media/sfu-logo-header-desktop.bb282754.svg";